import { RequestFormContext } from "../RequestFormContext";
import { CreateGenericChunkedUploader, GenerateUploadInput } from "./GenericChunkedUploader";
import { getRequestWithFiles } from "./mappers";

type UploadFilePayload = {
    id?: string;
    name?: string;
    extension?: string;
    size?: number;
    sessionId?: string;
    requestId?: string;
    requestTypeId?: number;
    taxonomy?: { id?: number } | null;
    uploadCompleted?: boolean;
};

export const createRequestFormFileUploader = (context: Omit<RequestFormContext, "pathToProp">) => {
    function generateUploadInput(
        file: UploadFilePayload,
        byteArray: Uint8Array,
        isEndOfFile: boolean
    ): GenerateUploadInput {
        return {
            requestId: file.requestId,
            requestTypeId: file.requestTypeId,
            parameters: [],
            isUploadFinished: isEndOfFile,
            uploadSessionId: file.sessionId,
            sendNotification: context.settings.current.sendNotification,
            fileToUpload: {
                id: file.id,
                fileId: file.id,
                fileName: file.name,
                fileExtension: file.extension,
                fileChunk: byteArray,
                size: file.size,
                taxonomy: file?.taxonomy,
                taxonomyId: file?.taxonomy?.id,
            },
        };
    }

    function uploadErrorHandler(file: UploadFilePayload) {
        let index = -1;
        const currentRequestWithFiles = getRequestWithFiles(context.request);

        for (let i = 0; i < currentRequestWithFiles.current.files.length; i++) {
            if (file.id === currentRequestWithFiles.current.files[i].id) {
                index = i;
                break;
            }
        }

        currentRequestWithFiles.current.files.splice(index, 1);
        context.uploadInCompletedNotifierTask.debouncedPerform();
    }

    function fileUploadCompleted(file: UploadFilePayload) {
        file.uploadCompleted = true;
    }

    function fileUploadProgressUpdate() { }

    function uploadService(input: Record<string, unknown>): Promise<Record<string, unknown>> {
        return new Promise(function (resolve, reject) {
            context.requestApi
                .uploadFile(input)
                .then(function (result) {
                    if (result.errorMessage) {
                        const globalInvalidErrorMessage = result.errorMessage;
                        const showFileLoading = false;
                        const uploadProcesses = context.settings.current.uploadProcesses;
                        uploadProcesses.splice(0, 1);

                        context.settings.current = {
                            ...context.settings.current,
                            globalInvalidErrorMessage,
                            showFileLoading,
                            uploadProcesses,
                        };
                        reject(result.errorMessage);
                        context.rerenderForm();
                    } else {
                        resolve(result);
                        context.rerenderForm();
                    }
                })
                .catch(function (err) {
                    const showFileLoading = false;
                    const uploadProcesses = context.settings.current.uploadProcesses;
                    uploadProcesses.splice(0, 1);
                    const globalInvalidErrorMessage = "Nastala chyba pri nahrávaní súborov";

                    context.settings.current = {
                        ...context.settings.current,
                        globalInvalidErrorMessage,
                        showFileLoading,
                        uploadProcesses,
                    };
                    reject(err);
                    context.rerenderForm();
                });
        });
    }

    return CreateGenericChunkedUploader(
        generateUploadInput,
        uploadService,
        uploadErrorHandler,
        3145728, // TODO: get from server
        fileUploadProgressUpdate,
        fileUploadCompleted,
        1499000 // TODO: get from server
    );
};
